import Container from './Container'
export default Container


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/Container/index.js